import { z } from 'zod/v4';
import { MatcherWrapperDTO } from './matcher';
export const AdvancedTQLFilterDTO = z.object({
  nodes: z.record(z.string(), MatcherWrapperDTO),
  _meta: z.record(z.string(), z.any()).optional(),
});

export type AdvancedTQLFilter = z.infer<typeof AdvancedTQLFilterDTO>;